<div
    *ngIf="displayMultiselect"
    [class.multiselect--active]="isMultiselect"
    (click)="toggleMultiselect()"
    class="multiselect">
        {{ isMultiselect ? 'Stop' : 'Start' }} Multi Selection
</div>

<div class='tree-wrapper' #tree [ngClass]="isDarkTheme() ? 'theme-dark' : 'theme-light'">
    <mat-tree *ngIf="dataSource.data !== null" [dataSource]="dataSource" [treeControl]="treeControl">

        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="15">
            <ng-container *ngIf="!node.$hidden">
                <div class="leaf-node-wrapper" (click)="onNodeSelection(node, true)">
                    <div class="leaf-node-icon">
                        <ng-container *ngFor="let attribute of node | keyvalue">
                            <cl-basic-tree-icon class="{{ node.$color }}" [iconName]="attribute.key" *ngIf="isIcon(attribute)"></cl-basic-tree-icon>
                        </ng-container>
                    </div>
                    <span
                        class="node cursor-pointer"
                        [ngClass]="node.$color"
                        [class.node__selected]="node.$selected">
                        {{ node.name }}
                    </span>
                    <ng-container *ngFor="let attribute of node | keyvalue">
                        <cl-basic-tree-tooltip [tooltipName]="attribute.key" *ngIf="isTooltip(attribute)"></cl-basic-tree-tooltip>
                    </ng-container>
                </div>
            </ng-container>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="15">
            <ng-container *ngIf="!node.$hidden">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>
                <div class="mat-tree-node">
                    <span
                        (click)="onNodeSelection(node, true)"
                        class="node cursor-pointer"
                        [ngClass]="node.$color"
                        [class.node__selected]="node.$selected"
                        [class.node__active-path]="node.$highlightedPath">
                            {{ node.name }}
                    </span>
                    <ng-container *ngFor="let attribute of node | keyvalue">
                        <cl-basic-tree-tooltip [tooltipName]="attribute.key" *ngIf="isTooltip(attribute)"></cl-basic-tree-tooltip>
                    </ng-container>
                    <cl-basic-tree-tooltip [tooltipName]="node?.$preloaderType" *ngIf="node?.$isPreloader"></cl-basic-tree-tooltip>
                    <mat-icon
                        class="icon node__icon cursor-pointer ml-10"
                        [class.node__icon--active]="node.$selected"
                        (click)="treeControl.expandDescendants(node)">
                            add_circle_outline
                    </mat-icon>
                    <mat-icon
                        class="icon node__icon cursor-pointer ml-10"
                        [class.node__icon--active]="node.$selected"
                        (click)="treeControl.collapseDescendants(node)">
                            remove_circle_outline
                    </mat-icon>
                    <ng-container *ngFor="let customButton of customButtons">
                        <mat-icon
                            class="icon node__icon cursor-pointer ml-10"
                            [class.node__icon--active]="node.$selected"
                            (click)="customButtonClicked.emit({node: node, eventName: customButton.eventName});">
                                {{ customButton.iconName }}
                        </mat-icon>
                    </ng-container>
                </div>
            </ng-container>
        </mat-tree-node>
    </mat-tree>
</div>
